import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import { dateFormattedWithUserLocale } from 'javascripts/util/dateFns';

export class LastPortalCommentAt extends Field {
  static attributesForModel() {
    return ['lastPortalCommentAt'];
  }

  get title() {
    return 'Last portal comment at';
  }

  exampleContents(): FieldContentsData {
    return { text: '2025-10-14', icon: { name: 'fa-regular fa-comment' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.lastPortalCommentAt) {
      return {
        text: dateFormattedWithUserLocale(record.lastPortalCommentAt),
        icon: { name: 'fa-regular fa-comment' },
      };
    }

    return {};
  }
}
